import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';

import { FeatureFlagProvider } from 'contexts/FeatureFlagContext';
import { UserProvider } from 'contexts/UserContext';
import { MessageCenterContextProvider } from 'contexts/MessageCenterContext';
import {
  QueryClient as TanstackQueryClient,
  QueryClientProvider as TanstackQueryClientProvider,
} from '@tanstack/react-query';
import { App } from './App';
import { StateContextProvider } from './contexts/StateContext';
import initializeDatadog from './config/initializers/datadog';
import initializeFullstory from './config/initializers/fullstory';
import initI18n from './config/initializers/i18n';
import './static/fonts/avenir/MyFontsWebfontsKit.css';
import '@sighten/beacon/core.css';

initializeDatadog();
initializeFullstory();
initI18n();

document.body.setAttribute('data-app-version', import.meta.env.VITE_APP_VERSION);

const container = document.getElementById('root');
const root = createRoot(container!);
const queryClient = new QueryClient();

// Create a client
const tanstackQueryClient = new TanstackQueryClient();

root.render(
  <React.StrictMode>
    <TanstackQueryClientProvider client={tanstackQueryClient}>
      <QueryClientProvider client={queryClient}>
        <FeatureFlagProvider>
          <StateContextProvider>
            <UserProvider>
              <MessageCenterContextProvider>
                <App />
              </MessageCenterContextProvider>
            </UserProvider>
          </StateContextProvider>
        </FeatureFlagProvider>
      </QueryClientProvider>
    </TanstackQueryClientProvider>
  </React.StrictMode>,
);
